import React, { Component } from "react";
import { BiSearch } from "react-icons/bi";
import { BsDot } from "react-icons/bs";
import { MdClose } from "react-icons/md";
import { Link } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import checkLength from "../../utils/check_length";
import Image from "../micro/Image";
import Spinner from "../micro/Spinner";

class AccountsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAccount:
        localStorage.getItem("selected_shop") &&
        JSON.parse(localStorage.getItem("selected_shop")),
      redirect: false,
      accounts_modal: false,
      searchKey: "",
    };
  }

  setShop(account) {
    if (
      !this.state.selectedAccount ||
      this.state.selectedAccount.uid !== account.uid ||
      !window.location.pathname.includes("dashboard")
    ) {
      localStorage.setItem(`selected_shop`, JSON.stringify(account));
      this.setState(
        { selectedAccount: account },
        () =>
          (window.location.href = `/dashboard/${this.state.selectedAccount.uid}`)
      );
    } else {
      this.props.changeModal(false);
    }
  }
  setUser() {
    if (this.state.selectedAccount) {
      localStorage.removeItem(`selected_shop`);
      window.location.href = "/";
    } else {
      this.props.changeModal(false);
    }
  }

  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.props.accounts_modal}
          toggle={() => this.props.changeModal(!this.props.accounts_modal)}
        >
          <ModalBody className="row mx-0 px-4 py-3">
            {this.props.accounts && this.props.accounts.length > 5 && (
              <div className="row mx-0 px-3 py-1 border rounded14 mt-3">
                <div className="col-auto px-0 align-self-center">
                  <BiSearch className="ms-2" size="25" />
                </div>
                <div className="col px-0">
                  <input
                    autoFocus={true}
                    type="text"
                    value={this.state.searchKey}
                    onChange={(e) =>
                      this.setState({ searchKey: e.target.value })
                    }
                    className="px-3 py-2 rounded14 border-0 w-100"
                    style={{ height: "44px" }}
                    placeholder="جستجو کنید"
                  />
                </div>
                {this.state.searchKey && (
                  <div className="col-auto px-0 align-self-center">
                    <MdClose
                      size={26}
                      onClick={() => this.setState({ searchKey: "" })}
                    />
                  </div>
                )}
              </div>
            )}
            {this.props.accounts ? (
              <section>
                <div
                  className="col-12 px-0 py-2"
                  onClick={() => this.setUser()}
                >
                  <div className="row mx-0">
                    <div className="col-2 px-0 align-self-center">
                      <Image
                        imageHeight={"50"}
                        imageWidth={"50"}
                        extraClassName={"p-0 img-contain"}
                        imgClassName={"rounded-circle img-cover"}
                        isProfile={true}
                        imageUri={
                          this.props.user.image && this.props.user.image
                        }
                      />
                    </div>
                    <div className="col px-1 align-self-center">
                      <p className="mb-0 fw-bold fs-6">
                        {checkLength(this.props.user.name, 25)}
                      </p>
                    </div>
                    <div className="col-1 px-1 align-self-center">
                      <input
                        width="30"
                        class="form-check-input mt-0 align-middle color-second"
                        type="radio"
                        name="exampleRadios"
                        checked={!this.state.selectedAccount}
                      />
                    </div>
                  </div>
                </div>
                {this.props.accounts
                  .filter((item) => item.title.includes(this.state.searchKey))
                  .map((account, a) => (
                    <div
                      className="col-12 px-0 py-2"
                      onClick={() => this.setShop(account)}
                    >
                      <div className="row mx-0">
                        <div className="col-2 px-0 align-self-center">
                          <Image
                            imageHeight={"50"}
                            imageWidth={"50"}
                            extraClassName={"rounded-circle p-2 bg-color-main"}
                            imgClassName={"rounded-circle img-cover"}
                            imageUri={account.cover && account.cover.thumbnail}
                          />
                        </div>
                        <div className="col px-1 align-self-center">
                          <p className="mb-0 fw-bold fs-6">
                            {checkLength(account.title, 25)}
                          </p>
                          {account.description && (
                            <p className="mb-0 fs-6 text-muted">
                              <BsDot
                                className="text-danger ms-1 align-middle"
                                size={30}
                              />
                              {account.description}
                            </p>
                          )}
                        </div>
                        <div className="col-1 px-1 align-self-center">
                          <input
                            width="30"
                            class="form-check-input mt-0 align-middle color-second"
                            type="radio"
                            name="exampleRadios"
                            checked={
                              this.state.selectedAccount &&
                              this.state.selectedAccount.uid === account.uid
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                <div className="py-3 text-center mt-3">
                  <Link to={"/new-shop"}>
                    <span className="color-main fw-bold">ثبت فروشگاه جدید</span>
                  </Link>
                </div>
              </section>
            ) : (
              <Spinner />
            )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default AccountsModal;
